<template>
	<div class="clipboard-toast">
		<p>Oops! We couldn't copy the {{ artifactType }} link to the clipboard. You can still copy it manually:</p>
		<v-text-field
			:value="url"
			outlined
      aria-label="Copyable media link"
			dense
			readonly
			class="clipboard-text-field"
			ref="clipboardTextInputField"></v-text-field>
		<v-btn
			color="white"
			rounded
			elevation="0"
			class="clipboard-copy-button"
			@click="copyLink"
			v-test="'clipboard-toast-copy-button'"
			v-track="'clipboard-toast-copy-button'">
			Copy
		</v-btn>
	</div>
</template>

<script>
	import { calculateTimeout } from "@/helpers/utilities";
	export default {
		props: {
			url: {
				type: String,
				required: true,
			},
			artifactType: {
				type: String,
				default: "media",
			},
			onClose: {
				type: Function,
				required: false,
			},
		},
		methods: {
			async copyLink() {
				try {
					await navigator.clipboard.writeText(this.url);
					const message = `The ${this.artifactType} link has been copied to the clipboard.`;
					this.$toast.success(message, { timeout: calculateTimeout(message) });
					this.onClose && this.onClose();
				} catch (error) {
					const message = `Failed to copy the ${this.artifactType} link. Please copy it manually.`;
					this.$toast.error(message, { timeout: calculateTimeout(message) });
					console.error("Failed to copy link:", error);
				}
			},
		},
	};
</script>

<style scoped>
	.clipboard-toast {
		display: flex;
		flex-direction: column;
		align-items: flex-end;
		gap: 10px;
	}

	.clipboard-text-field {
		width: 100%;
	}

	.clipboard-toast .clipboard-text-field ::v-deep(.v-input__control > .v-input__slot) {
		background-color: #fff !important;
	}

	.clipboard-toast .clipboard-text-field ::v-deep(fieldset) {
		border-color: #888888 !important;
	}

	.clipboard-text-field ::v-deep(input[type="text"]) {
		color: #888888 !important;
	}

	.clipboard-copy-button ::v-deep .v-btn__content {
		color: #2196f3 !important;
		font-size: 0.875rem;
		font-weight: 600;
	}

	.clipboard-text-field ::v-deep .v-text-field__details {
		display: none !important;
	}
</style>
